import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  descriptionHtml:
    "Play with the passive radiator parameters to see their effect on the impedance and frequency response curve.  The resonance frequency f<sub>p</sub> or the loss term R<sub>mp</sub> can be adjusted as a function of the driver parameters. For example, the default value f<sub>p</sub>=0.66f<sub>s</sub> means that the resonance frequency of the passive radiator is two thirds of the value of the loudspeaker’s one.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0422/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
